export const position=[
    "GK",
    "SW",
    "RWB",
    "RB",
    "RCB",
    "CB",
    "LCB",
    "LB",
    "LWB",
    "RDM",
    "CDM",
    "LDM",
    "RM",
    "RCM",
    "CM",
    "LCM",
    "LM",
    "RAM",
    "CAM",
    "LAM",
    "RF",
    "CF",
    "LF",
    "RW",
    "RS",
    "ST",
    "LS",
    "LW"
]